import { render, staticRenderFns } from "./TotalInflowModal.vue?vue&type=template&id=1f8d8fb2"
import script from "./TotalInflowModal.vue?vue&type=script&lang=js"
export * from "./TotalInflowModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports